/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get, isObject, isString } from 'lodash';

// Mixins
import formattable from 'shared/ui/mixins/table/formattable';

const __vue_script__ = {
    name: 'SmartTableData',

    mixins: [formattable],

    props: {
        event: {
            type: Object,
            required: true
        },

        config: {
            type: Object,
            required: true
        },

        item: {
            type: Object,
            required: true
        },

        module: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        component() {
            return this.getCustomComponent(this.config);
        },

        content() {
            return this.render();
        },

        href() {
            return this.cellLink(this.config);
        },

        style() {
            return this.cellContentStyle();
        },

        /**
         * Retrieves the subtext for a given item based on its cell configuration.
         * @returns {string} The subtext associated with the item.
         */
        subtext() {
            if (!this.config.subtext) {
                return;
            }

            if (Array.isArray(this.config.subtext.fields)) {
                return this.config.subtext.fields
                    .map(subtext => get(this.item, subtext))
                    .filter(Boolean)
                    .join(' · ');
            } else {
                return get(this.item, this.config.subtext.field);
            }
        }
    },

    methods: {
        /**
         * Renders the cell with the given field and item
         * @returns {string} a human readable version of the given field
         */
        render() {
            const formatted = this.config.format && this.renderFormatted(this.config, this.item);
            if (formatted) { return formatted; }

            const config = get(this.metadata, this.config.field);
            let value = get(this.item, this.config.field);

            if (config?.kind_options?.values?.hasOwnProperty(value)) {
                value = config.kind_options.values[value];
            } else if (!value && this.config.emptyFieldLabel) {
                value = this.$utils.strings.compileWithObject(this.config.emptyFieldLabel, this.item);
            }

            // If empty, return 'x'; otherwise, the value
            value = value ?? '×';
            if (isString(value)) {
                value = value.trim().length ? value : '×';
            } else {
                value = `${value}`;
            }

            return value;
        },

        /**
         * Compiles a link in the context of the given cell
         * @returns {string} a compiled version of the link for this cell
         */
        cellLink(context) {
            if (!context.link) {
                return null;
            }

            let module = this.module;
            if (context.link.moduleName) {
                module = this.$services.blueprint.getModuleByName(context.link.moduleName);
            }

            return this.$utils.tables.cellLink(context.link, this.item, module, this.event);
        },

        /**
         * Generates the style for the content of a cell based on the cell configuration and item data.
         * @returns {Object} The style object to be applied to the cell content.
         */
        cellContentStyle() {
            if (!this.config.style) {
                return;
            }

            return this.$utils.strings.compileWithObject(this.config.style, this.item);
        },

        /**
         * Retrieves the component associated with a given context.
         *
         * @param {Object} context - The context object for which the component is to be retrieved.
         *
         * @returns {Object} The component associated with the specified action.
         */
        getCustomComponent(context) {
            if (!context.component) {
                return null;
            }

            if (isObject(context.component)) {
                // If the component is a string, it is a registered component.
                // If the component is an object, it means that the component itself is being passed, no need for lookup.
                return context.component;
            }

            const SET = { ...this.$const.CUSTOM_ACTIONS_COMPONENTS, ...this.$const.CUSTOM_CELLS_COMPONENTS };
            const component = SET[context.component];

            if (!component) {
                console.warn('[SmartTableData] Component `%s` not registered.', context.component);
                return null;
            }

            return component;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:_vm.$utils.tables.cellClasses(_vm.config, _vm.item)},[(_vm.component)?_c(_vm.component,_vm._b({tag:"component",attrs:{"cell":_vm.config,"item":_vm.item,"event":_vm.event}},'component',_vm.config.props,false),[_vm._v(_vm._s(_vm.content))]):(_vm.config.actions)?_vm._l((_vm.config.actions),function(action){return [(action.controllerKey)?_c('router-link',{class:action.cssClass,style:(_vm.style),attrs:{"to":_vm.cellLink({ link: action }),"disabled":!_vm.cellLink({ link: action }),"target":action.hasOwnProperty('target') ? action.target : '_blank'}},[_vm._v(_vm._s(_vm.$te(action.label) ? _vm.$t(action.label) : action.label))]):_c(_vm.getCustomComponent(action),_vm._b({tag:"component",attrs:{"action":action,"cell":_vm.config,"item":_vm.item,"event":_vm.event}},'component',action.props,false))]}):[(_vm.href)?_c('router-link',{attrs:{"to":_vm.href,"disabled":!_vm.href}},[_c('span',{style:(_vm.style)},[_vm._v(_vm._s(_vm.content))])]):_c('span',{style:(_vm.style)},[_vm._v(_vm._s(_vm.content))])],(_vm.subtext)?_c('div',{staticClass:"sub-text"},[_c('small',[_vm._v(_vm._s(_vm.subtext))])]):_vm._e()],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "SmartTableData.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__